import { render, staticRenderFns } from "./StatementMore.vue?vue&type=template&id=4bfa8bbe&scoped=true"
import script from "./StatementMore.vue?vue&type=script&lang=js"
export * from "./StatementMore.vue?vue&type=script&lang=js"
import style0 from "./StatementMore.vue?vue&type=style&index=0&id=4bfa8bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa8bbe",
  null
  
)

export default component.exports